import React from "react";

export default function ExperienceImg(props) {
  const theme = props.theme;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="-50 0 600 600"
    >
      <g id="Background_Simple">
        <path
          fill={theme.accentColor}
          d="M183.511 78.444c-7 .075-13.984.327-20.908 1.118C82.689 88.685-1.81 176.901 35.439 259.573c8.878 19.704 24.831 32.903 37.891 49.654 29.704 38.099 35.644 84.876 60.865 124.793 19.552 30.942 56.562 46.326 91.542 51.66 38.011 5.797 69.993-1.193 101.869-21.868 35.735-23.179 47.585-60.955 58.241-99.782 4.792-17.462 9.766-35.449 18.968-51.185 11.52-19.701 27.346-36.961 40.19-55.811 13.358-19.604 24.828-41.12 28.327-64.618 11.206-75.25-78.705-138.659-147.717-139.428-24.428-.272-47.577 8.255-70.384 15.526-24.619 7.85-45.819 9.653-71.72 9.93"
        ></path>
        <path
          fill="#FFF"
          d="M183.511 78.444c-7 .075-13.984.327-20.908 1.118C82.689 88.685-1.81 176.901 35.439 259.573c8.878 19.704 24.831 32.903 37.891 49.654 29.704 38.099 35.644 84.876 60.865 124.793 19.552 30.942 56.562 46.326 91.542 51.66 38.011 5.797 69.993-1.193 101.869-21.868 35.735-23.179 47.585-60.955 58.241-99.782 4.792-17.462 9.766-35.449 18.968-51.185 11.52-19.701 27.346-36.961 40.19-55.811 13.358-19.604 24.828-41.12 28.327-64.618 11.206-75.25-78.705-138.659-147.717-139.428-24.428-.272-47.577 8.255-70.384 15.526-24.619 7.85-45.819 9.653-71.72 9.93"
          opacity="0.7"
        ></path>
      </g>
      <g
        id="Grid"
        fill="none"
        stroke="#000"
        strokeMiterlimit="10"
        opacity="0.3"
      >
        <path d="M33.513 53.849v417.933M81.424 53.849v417.933M129.336 53.849v417.933M177.247 53.849v417.933M225.158 53.849v417.933M273.069 53.849v417.933M320.98 53.849v417.933M368.891 53.849v417.933M416.802 53.849v417.933M464.714 53.849v417.933M486.089 95.127H12.138M486.089 143.038H12.138M486.089 190.949H12.138M486.089 238.86H12.138M486.089 286.771H12.138M486.089 334.682H12.138M486.089 382.593H12.138M486.089 430.504H12.138"></path>
      </g>
      <g id="Arrows_2">
        <path
          d="m223.977 81.277-3.209-37.873a7.762 7.762 0 0 0-10.018-6.764l-37.552 11.554a7.763 7.763 0 1 0 4.566 14.84l16.131-4.964-60.381 79.85-38.357-1.162a7.78 7.78 0 0 0-6.088 2.66l-47.822 54.883a7.763 7.763 0 0 0 11.706 10.2l45.408-52.112 38.692 1.173a7.8 7.8 0 0 0 6.427-3.078l63.648-84.17 1.379 16.273a7.764 7.764 0 0 0 8.391 7.08 7.76 7.76 0 0 0 7.079-8.39M426.303 334.456l-3.598-42.457c-.153-1.807-.762-3.575-1.897-4.989a8.82 8.82 0 0 0-9.495-2.94l-42.332 13.025c-4.486 1.38-7.361 5.971-6.273 10.536a8.81 8.81 0 0 0 11.167 6.396l18.309-5.633-50.336 66.48a8.81 8.81 0 0 0 1.423 12.121c3.866 3.183 9.604 2.509 12.626-1.483l51.305-67.761 1.565 18.47a8.812 8.812 0 0 0 11.501 7.639c3.955-1.27 6.386-5.265 6.035-9.404M261.249 413.432l-3.598-42.459c-.153-1.807-.762-3.574-1.898-4.989a8.82 8.82 0 0 0-9.495-2.939l-42.332 13.025c-4.486 1.38-7.361 5.971-6.273 10.536a8.81 8.81 0 0 0 11.167 6.396l18.309-5.634-51.401 67.974a8.81 8.81 0 0 0 1.427 12.116c3.867 3.185 9.608 2.509 12.63-1.487l52.363-69.246 1.565 18.47a8.812 8.812 0 0 0 11.501 7.639c3.955-1.267 6.386-5.262 6.035-9.402M324.628 47.956l-1.988-23.454c-.085-.999-.421-1.975-1.048-2.756a4.87 4.87 0 0 0-5.245-1.623l-23.384 7.195c-2.478.763-4.066 3.298-3.465 5.82a4.87 4.87 0 0 0 6.169 3.533l10.114-3.112-28.393 37.548a4.868 4.868 0 1 0 7.765 5.871l28.925-38.251.865 10.203a4.868 4.868 0 0 0 6.352 4.22c2.184-.701 3.526-2.908 3.333-5.194"
          opacity="0.15"
        ></path>
      </g>
      <g
        id="Arrow_1"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      >
        <path
          fill="#263238"
          d="m457.213 170.225-7.441-87.812a17.997 17.997 0 0 0-23.229-15.684l-87.067 26.79c-9.501 2.924-14.834 12.996-11.91 22.497 2.923 9.502 12.993 14.834 22.498 11.911l37.402-11.508-140.002 185.142-88.936-2.695a18.04 18.04 0 0 0-14.116 6.167L33.531 432.285c-6.531 7.495-5.749 18.865 1.746 25.396a17.93 17.93 0 0 0 11.817 4.429c5.022 0 10.02-2.091 13.578-6.175l105.283-120.828 89.712 2.719c5.813.151 11.384-2.483 14.902-7.136l147.575-195.157 3.197 37.731c.796 9.389 8.662 16.481 17.915 16.481q.765 0 1.54-.065c9.907-.838 17.257-9.549 16.417-19.455"
        ></path>
        <path
          fill={theme.accentColor}
          d="m464.854 162.915-7.441-87.812a17.997 17.997 0 0 0-23.229-15.684l-87.067 26.79c-9.501 2.924-14.834 12.996-11.91 22.497 2.923 9.502 12.993 14.834 22.498 11.911l37.402-11.508-140.003 185.142-88.936-2.695a18.04 18.04 0 0 0-14.116 6.167L41.172 424.976c-6.531 7.495-5.749 18.865 1.746 25.397a17.93 17.93 0 0 0 11.817 4.429c5.022 0 10.02-2.091 13.578-6.175l105.283-120.828 89.712 2.719c5.814.151 11.384-2.483 14.902-7.136l147.575-195.157 3.197 37.731c.796 9.389 8.662 16.481 17.915 16.481q.765 0 1.54-.065c9.907-.84 17.257-9.551 16.417-19.457"
        ></path>
      </g>
      <g
        id="Character"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      >
        <path
          fill="#263238"
          stroke="#263238"
          d="m227.678 245.081-16.652-.968-6.802-2.13s-15.989-18.699-29.81-28.726-41.192-28.455-43.631-24.932 2.981 87.804 2.981 87.804-5.149 2.71-5.962 4.336-27.1 62.601-27.1 62.601-4.607-1.355-5.42.271-3.794 8.943-3.794 8.943l-13.821-1.355s-9.756-2.439-15.176-4.336-4.065 2.439-2.71 4.336 18.157 17.073 18.157 17.073l10.569 7.588s4.336 1.084 5.42-.813 11.924-14.363 11.924-14.363 2.981-2.168 4.336-3.523 3.252-6.504 3.252-6.504l28.184-34.688 15.176-17.073h85.907s4.878-2.168 7.046-7.859l2.168-5.691zm-77.654 27.255 4.878-36.314 23.848 29.81z"
        ></path>
        <g fill="#FFF" stroke="#263238">
          <path d="m332.313 165.437-18.841 9.531-4.877 10.418 23.275-.222s5.763-12.413 5.985-16.181c.222-3.767-5.542-3.546-5.542-3.546"></path>
          <path d="M325.904 176.944s-1.084-7.588 0-8.672 14.363-9.214 17.073-9.214 9.756 2.168 10.027 2.981.813 3.523.813 4.607-8.13 7.588-9.214 8.943-18.699 1.355-18.699 1.355"></path>
        </g>
        <path
          fill="#FFF"
          stroke="#263238"
          d="m300.638 196.3 10.242-.387s13.721-18.552 16.62-21.838c2.899-3.285 10.822-10.242 19.519-11.402s9.856 3.092 9.856 4.638-8.503 16.62-12.368 24.736c-3.865 8.117-7.73 12.948-8.696 14.881s-11.209 19.905-13.141 23.19-13.141 11.595-14.687 13.528-13.721 20.678-21.258 26.669-20.485 11.788-20.485 11.788-5.991 4.252-9.469 5.991c-3.479 1.739-7.344 1.353-8.696.773s-11.982-9.469-17.779-18.939c-5.798-9.469-5.798-23.577-5.411-24.93s3.672-3.479 4.638-3.672 10.822-2.706 10.822-2.706l7.923-5.798s.58-3.092 1.353-4.058 16.62-18.359 16.62-18.359l5.991-6.957 14.107-3.672z"
        ></path>
        <g fill="none" stroke="#263238">
          <path d="M257.63 254.939c4.484.037 10.114-.362 17.055-1.573M242.855 252.343s3.456 2.063 11.983 2.512M254.702 262.315c1.063.248 2.13.435 3.181.536M239.996 255.805s5.719 3.758 12.209 5.819M277.915 239.191c-6.096 1.595-17.943 4.671-23.827 6.044M281.731 238.19s-.642.17-1.742.458M297.896 215.218a115 115 0 0 0-1.704 2.726M310.88 195.913s-7.043 10.2-11.695 17.317M308.948 197.459s-10.629 7.15-15.074 11.982"></path>
        </g>
        <g stroke="#263238">
          <path
            fill="#FFF"
            d="M286.144 154.364s-10.629 5.991-10.629 7.344v2.899s-6.377 4.445-8.696 5.798 2.126 4.831 2.126 4.831l-5.991 14.494s1.739 3.092 3.092 3.285 8.503.386 8.503.386l2.512 6.764 25.123-5.218-1.159-4.058s10.049-4.252 14.107-7.15 6.571-14.494 3.285-21.644-6.377-11.016-9.663-12.755c-3.285-1.739-11.015-1.739-11.015-1.739s5.604-5.798.193-5.991-7.73 4.252-7.73 4.252-3.479-5.218-6.377-1.353c-2.899 3.864 2.319 9.855 2.319 9.855"
          ></path>
          <path
            fill="#263238"
            d="m274.548 193.401 5.803-.109-3.711 4.584z"
          ></path>
          <path
            fill="none"
            d="M278.993 163.447s4.058-1.353 5.411 3.092M279.766 166.732l-2.512 2.319s.58.773 3.672 1.739M271.65 178.134s1.546 2.126 6.957 0"
          ></path>
        </g>
        <path
          fill="#263238"
          stroke="#263238"
          d="M308.754 149.339c-3.285-1.739-11.015-1.739-11.015-1.739s5.604-5.798.193-5.991-7.73 4.252-7.73 4.252-3.479-5.218-6.377-1.353c-2.899 3.865 2.319 9.856 2.319 9.856s1.739.966 4.058 1.739 6.764 1.353 7.344 2.512-7.73 4.252-6.957 5.991 2.512 6.764 2.512 6.764-3.479 4.252-2.899 4.831 2.126 2.319 2.706 2.319 5.025-2.899 5.604-2.899c.58 0 3.478.193 3.092 4.445s-5.411 6.184-7.73 6.571l-2.319.387s2.512 2.126 3.285 3.285 6.184.58 6.184.58 10.049-4.252 14.107-7.15 6.571-14.494 3.285-21.644c-3.284-7.152-6.376-11.017-9.662-12.756"
        ></path>
        <g fill={theme.accentColor} stroke="#263238">
          <path d="M268.171 216.398s-4.445 30.148-4.831 34.013-.387 23.384-.387 23.384l7.73 7.537 6.957-8.89-5.411-26.669-2.706-29.954zM270.49 206.542l-2.319 9.856 15.654-10.049z"></path>
        </g>
        <path
          fill="#FFF"
          stroke="#263238"
          d="m301.024 190.889-29.181 8.696.966 11.788 31.694-15.267z"
        ></path>
        <g fill="#FFF" stroke="#263238">
          <path d="m272.229 202.097-6.377-.386 7.344 7.537zM265.852 201.711l.387 8.696 4.251-3.865z"></path>
        </g>
        <path
          fill="none"
          stroke="#FFF"
          d="M153.276 233.041s-10.027-17.886-14.634-25.745M135.932 211.632l7.046 5.962"
        ></path>
        <g fill="none" stroke="#FFF">
          <path d="M111.542 326.265s23.577-14.092 38.211-23.035M133.222 308.108s13.008-5.962 16.26-8.943"></path>
        </g>
      </g>
      <g
        id="Device"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      >
        <path
          fill="#FFF"
          d="m188.357 203.643-24.736 10.629 28.795 42.516 15.846-18.746z"
        ></path>
        <path
          fill={theme.accentColor}
          d="m188.164 205.769-21.984 9.199 26.491 39.115 13.806-16.667z"
        ></path>
        <path
          fill="#FFF"
          d="m208.262 238.042 38.844-6.377-4.251 20.678-50.439 4.445z"
        ></path>
        <g strokeWidth="0.75">
          <path
            fill="none"
            d="m230.177 238.474.742-1.962-3.833.611-.841 1.936z"
          ></path>
          <path
            fill="#FFF"
            d="m206.238 250.26 4.044-.471 1.213-1.861-3.795.455z"
          ></path>
          <path
            fill="none"
            d="m230.833 239.287-.81 2.144 3.457-.488.805-2.17zM233.151 244.426l4.442-.533.967-2.757-4.421.625z"
          ></path>
          <path
            fill="#FFF"
            d="m218.394 243.984-3.582.505-1.508 2.315 3.856-.462zM220.526 239.91l.996-1.901-2.775.442-1.245 1.91zM216.653 247.31l-3.991.478-1.215 1.866 4.237-.493zM213.627 244.657l-3.398.479-1.749 2.246 3.656-.438z"
          ></path>
          <path
            fill="none"
            d="m234.642 237.81.744-2.009-3.441.548-.746 1.973z"
          ></path>
          <path
            fill="#FFF"
            d="m199.904 251.904-1.884 2.178 4.494-.509 1.689-2.169zM221.768 249.362l-.926 2.132 4.608-.522.807-2.132zM210.806 250.637l-1.404 2.155 4.658-.528 1.118-2.136z"
          ></path>
          <path
            fill="none"
            d="m226.457 250.858 3.496-.397.794-2.143-3.482.405zM234.495 240.8l4.401-.622.773-2.206-4.367.65z"
          ></path>
          <path
            fill="#FFF"
            d="m223.853 242.302.918-2.113-3.658.545-1.106 2.111zM211.389 242.181l-3.53.526-1.827 2.111 3.71-.523zM225.194 239.216l.836-1.925-3.398.541-1.002 1.914zM211.026 244.113l3.254-.459 1.373-2.108-2.971.443z"
          ></path>
          <path
            fill="none"
            d="m231.793 245.496-3.465.415-.704 1.862 3.475-.405zM237.261 244.84l-4.462.535-.695 1.877 4.495-.523zM233.124 241.904l-3.465.489-.971 2.567 3.457-.414z"
          ></path>
          <path
            fill="#FFF"
            d="m215.465 243.487 3.444-.487 1.1-2.102-3.164.471zM205.46 251.258l-1.692 2.173 4.472-.508 1.402-2.151z"
          ></path>
          <path
            fill="none"
            d="m235.659 237.658 4.348-.647.722-2.061-4.321.688zM231.752 248.201l-.795 2.146 4.554-.516.756-2.155z"
          ></path>
          <path
            fill="#FFF"
            d="m212.191 241.151 1.473-1.891-3.276.522-1.625 1.879zM216.261 250.002l-1.12 2.139 4.668-.529.925-2.13zM223.432 243.272l-3.939.557-1.248 2.383 4.124-.494z"
          ></path>
          <path
            fill="none"
            d="m227.319 246.032-4.329.519-.806 1.854 4.432-.515z"
          ></path>
          <path
            fill="#FFF"
            d="m206.44 248.534-4.04.484-1.623 1.877 4.205-.489z"
          ></path>
          <path
            fill="none"
            d="m228.641 242.537-4.162.588-1.073 2.468 4.272-.512z"
          ></path>
          <path
            fill="#FFF"
            d="m221.953 246.675-4.215.505-.971 1.855 4.382-.509z"
          ></path>
          <path
            fill="none"
            d="m229.812 239.439-3.99.594-.922 2.122 4.104-.58z"
          ></path>
          <path
            fill="#FFF"
            d="m208.945 245.318-3.81.538-1.86 2.15 3.944-.473zM216.311 240.538l1.235-1.896-2.577.41-1.485 1.907z"
          ></path>
        </g>
      </g>
    </svg>
  );
}
